var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current_size !== 'xs')?_c('div',[_c('left_panel_bookings_table_wrapper',{attrs:{"bookings":this.bookings,"height_correction":this.height_correction}})],1):_c('div',[_c('left_panel_bookings_table_wrapper_xs',{attrs:{"bookings":this.bookings,"height_correction":this.height_correction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }